import { useMemo } from "react";
import { AXNUIContent, AXNUIContentSubmitButtonType, AXNUITheme } from "@iddataweb/idw-common-ui/types";
import { AXNUIThemingConfirmButton } from "../axnui-theming-confirm-button/axnui-theming-confirm-button";
import styles from "./axnui-theming-form-button-container.less";

type AXNUIThemingFormButtonContainerProps = {
    axnuiContent: AXNUIContent;
    axnuiTheme: AXNUITheme;
    showAsyncButton: boolean;
    hasCancelButtonURLEnabled: boolean;
};

export const AXNUIThemingFormButtonContainer = (props: AXNUIThemingFormButtonContainerProps) => {
    const { axnuiContent, axnuiTheme, showAsyncButton, hasCancelButtonURLEnabled } = props;

    const syncButtonTextInternal = useMemo(() => {
        if (axnuiTheme.confirmButton.useCustomText) {
            return axnuiContent.confirmButton.buttonText;
        } else {
            const type = axnuiTheme.confirmButton.type as keyof AXNUIContentSubmitButtonType;
            return axnuiContent.submitButtonType[type];
        }
    }, [
        axnuiTheme.confirmButton.useCustomText,
        axnuiTheme.confirmButton.type,
        axnuiContent.confirmButton.buttonText,
        axnuiContent.submitButtonType
    ]);

    const containerStyle = useMemo(() => {
        if (hasCancelButtonURLEnabled) {
            return styles.formButtonContainerTwoButton;
        }

        return styles.formButtonContainer;
    }, [hasCancelButtonURLEnabled])

    return (
        <div className={styles.axnuiThemingFormButtonContainer} id="form-button-container">
            <div className={containerStyle}>
                {!showAsyncButton && (
                    <AXNUIThemingConfirmButton
                        id="verify-all"
                        className="verify-button verify-sync"
                        size="lg"
                        backgroundColor={axnuiTheme.confirmButton.backgroundColor}
                        borderWidth={axnuiTheme.confirmButton.borderWidth}
                        width={axnuiTheme.confirmButton.width}
                        textColor={axnuiTheme.confirmButton.textColor}
                        height={axnuiTheme.confirmButton.height}
                        cornerRadius={axnuiTheme.confirmButton.cornerRadius}
                        buttonText={syncButtonTextInternal}
                    />
                )}
                {showAsyncButton && (
                    <AXNUIThemingConfirmButton
                        id="async-submit"
                        className="verify-button verify-async"
                        size="lg"
                        backgroundColor={axnuiTheme.confirmButton.backgroundColor}
                        borderWidth={axnuiTheme.confirmButton.borderWidth}
                        width={axnuiTheme.confirmButton.width}
                        textColor={axnuiTheme.confirmButton.textColor}
                        height={axnuiTheme.confirmButton.height}
                        cornerRadius={axnuiTheme.confirmButton.cornerRadius}
                        buttonText={axnuiContent.confirmButton.asyncButtonText}
                    />
                )}

                {hasCancelButtonURLEnabled && (
                    <AXNUIThemingConfirmButton
                        id="cancel-button"
                        size="lg"
                        className="cancel-button"
                        backgroundColor={axnuiTheme.confirmButton.textColor}
                        borderWidth={axnuiTheme.confirmButton.borderWidth}
                        width={axnuiTheme.confirmButton.width}
                        textColor={axnuiTheme.confirmButton.backgroundColor}
                        height={axnuiTheme.confirmButton.height}
                        borderColor={axnuiTheme.confirmButton?.backgroundColor}
                        cornerRadius={axnuiTheme.confirmButton.cornerRadius}
                        buttonText={axnuiContent.common.button.cancel}
                    />
                )}
            </div>

        </div>
    );
};